export default __webpack_public_path__ + "static/media/doublering.c2c3f2f4.jpg";